export const AI_PROVIDER_IDS = ['openai', 'anthropic', 'gemini', 'custom'];

export const AI_PROVIDER_LABELS = {
  openai: 'OpenAI (ChatGPT API)',
  anthropic: 'Anthropic (Claude)',
  gemini: 'Google Gemini',
  custom: 'Custom AI Gateway (Cloudflare Access)',
};

export const AI_ACTION_KEYS = [
  'job_rematch',
  'resume_studio',
  'linkedin_studio',
  'profile_studio',
  'document_autofill',
];

export const AI_ACTION_LABELS = {
  job_rematch: 'ATS match pipeline (bulk rematch)',
  resume_studio: 'Resume Builder',
  linkedin_studio: 'LinkedIn Profile Enhancement',
  profile_studio: 'Candidate Profile Resume Quality',
  document_autofill: 'Document OCR autofill',
};

export function defaultProvidersEnabled() {
  return {
    openai: true,
    anthropic: false,
    gemini: false,
    custom: false,
  };
}

export function defaultActionProviders() {
  return {
    job_rematch: 'openai',
    resume_studio: 'openai',
    linkedin_studio: 'openai',
    profile_studio: 'openai',
    document_autofill: 'openai',
  };
}

export function getEnabledProviderIds(providersEnabled) {
  return AI_PROVIDER_IDS.filter((id) => Boolean(providersEnabled?.[id]));
}
